import { createAsyncThunk } from '@reduxjs/toolkit';
import { AgentDeactivationTransfer } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';

export interface AgentDeactivationTransferParams {
  agentId: string;
  reason?: string;
}

export const agentDeactivationTransfer = createAsyncThunk(
  'agentDeactivationTransfer/agentDeactivationTransfer',
  async (values: AgentDeactivationTransferParams, { rejectWithValue }) => {
    try {
      const response = await AgentDeactivationTransfer.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

